/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListNotificationsQueryResponse,
  ListNotificationsQueryParams,
} from '../../types/ListNotifications'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listNotifications } from '../../clients/listNotifications'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listNotificationsQueryKey = (
  params?: ListNotificationsQueryParams
) => [{ url: '/api/v1/notifications/' }, ...(params ? [params] : [])] as const

export type ListNotificationsQueryKey = ReturnType<
  typeof listNotificationsQueryKey
>

export function listNotificationsQueryOptions(
  params?: ListNotificationsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listNotificationsQueryKey(params)
  return queryOptions<
    ListNotificationsQueryResponse,
    ResponseErrorConfig<Error>,
    ListNotificationsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listNotifications(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary List the 5 most recent notifications for the current user
 * {@link /api/v1/notifications/}
 */
export function useListNotifications<
  TData = ListNotificationsQueryResponse,
  TQueryData = ListNotificationsQueryResponse,
  TQueryKey extends QueryKey = ListNotificationsQueryKey,
>(
  params?: ListNotificationsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListNotificationsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? listNotificationsQueryKey(params)

  const query = useQuery(
    {
      ...listNotificationsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
